<template>
    <div class="patient-contact-methods-display" v-if="participant.id">

        <b-row class="my-2">
            <b-col cols="6">
                <label>{{ $i18n.gt('LABEL_PATIENT_PRIVACY_WAIVED') }}</label>
            </b-col>
            <b-col cols="6">
                <span class="patient-contact-methods__contact__yes"
                      v-if="participant.contact_privacy_waived">
                    {{ $i18n.gt('FIELD_PARTICIPANT_CONTACT_PRIVACY_WAIVED_YES') }}
                </span>
                <span class="patient-contact-methods__contact__no"
                      v-else>
                    {{ $i18n.gt('FIELD_PARTICIPANT_CONTACT_PRIVACY_WAIVED_NO') }}
                </span>
            </b-col>
        </b-row>
        <b-row class="my-2" v-if="participant.email">
            <b-col cols="6">
                <label>{{ $i18n.gt('LABEL_PATIENT_EMAIL') }}</label>
            </b-col>
            <b-col cols="6">
                <div v-if="getStarLabel('email') !== null">
                    <label>
                        <b-icon icon="star-fill" variant="warning"></b-icon>
                        <!-- no label shown for this one -->
                    </label>
                </div>
            </b-col>
            <b-col cols="12">
                <a :href="`mailto:${participant.email}`">
                    {{ participant.email }}
                </a>
            </b-col>
        </b-row>
        <b-row class="my-2" v-if="participant.phone_primary">
            <b-col cols="6">
                <label>{{ $i18n.gt('LABEL_PATIENT_PRIMARY_PHONE') }}</label>
            </b-col>
            <b-col cols="6">
                <div v-if="getStarLabel('phone_primary') !== null">
                    <b-icon icon="star-fill" variant="warning"></b-icon>
                    {{ getStarLabel('phone_primary') }}
                </div>
            </b-col>
            <b-col cols="12">
                {{ participant.phone_primary }}
            </b-col>
        </b-row>
        <b-row class="my-2" v-if="participant.phone_secondary">
            <b-col cols="6">
                <label>{{ $i18n.gt('LABEL_PATIENT_SECONDARY_PHONE') }}</label>
            </b-col>
            <b-col cols="6">
                <div v-if="getStarLabel('phone_secondary') !== null">
                    <b-icon icon="star-fill" variant="warning"></b-icon>
                    {{ getStarLabel('phone_secondary') }}
                </div>
            </b-col>
            <b-col cols="12">
                {{ participant.phone_secondary }}
            </b-col>
        </b-row>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
/**
 * Displays contact info for the participant
 * */
import Vue from 'vue'

export default Vue.extend({
    name: 'PatientContactMethodsDisplay',
    props: {
        participant: Object,
    },
    methods: {
        preferredContactIncludes(method) {
            return !!this.participant.preferred_contact_method &&
                this.participant.preferred_contact_method.indexOf(method) != -1
        },
        // build a label for the star icon - e.g. '' (for email) or 'Call/Text' (for primary/secondary phone)
        getStarLabel(fieldName) {
            if (fieldName == 'email') {
                return this.preferredContactIncludes('EMAIL') ? '' : null
            } else {
                const labels = []
                if (fieldName == 'phone_primary') {
                    if (this.preferredContactIncludes('CALL_PRIMARY')) {
                        labels.push('Call')
                    }
                    if (this.preferredContactIncludes('TEXT_PRIMARY')) {
                        labels.push('Text')
                    }
                }
                if (fieldName == 'phone_secondary') {
                    if (this.preferredContactIncludes('CALL_SECONDARY')) {
                        labels.push('Call')
                    }
                    if (this.preferredContactIncludes('TEXT_SECONDARY')) {
                        labels.push('Text')
                    }
                }
                if (labels.length) {
                    return labels.join(' or ')
                } else {
                    return null
                }
            }
        },
    }
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

.patient-contact-methods-display {
    max-width: 270px;

    label {
        .b-icon {
            font-size: 1.2em;
        }
    }
}

.patient-contact-methods__contact__yes {
    font-weight: bold;
    color: var(--green) !important;
}

.patient-contact-methods__contact__no {
    font-weight: bold;
    color: var(--red) !important;
}

</style>
